import React, { useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";

import videojs from "video.js";
import "video.js/dist/video-js.css";
import Transcript from "./transcript/videojs-transcript";

import { useTranslation } from "react-i18next";

import parse from "html-react-parser";

import "./index.scss";

export default function BV(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const lang = "en";

  const videoNode = useRef(null);
  const transcriptArea = useRef(null);

  const [player, setPlayer] = useState(null);
  const [textTrack, setTextTrack] = useState(null);
  const [viewTranscript, setViewTranscript] = useState(false);

  useEffect(() => {
    setPlayer(
      videojs(
        videoNode.current,
        {
          sources: [
            {
              src: props.data.video,
              type: "application/x-mpegURL",
            },
          ],
          controlBar: {
            playToggle: true,
            captionsButton: true,
            chaptersButton: false,
            subtitlesButton: false,
            currentTime: true,
            currentTimeDisplay: true,
            liveCurrentTime: true,
            durationDisplay: true,
            progressControl: {
              seekBar: true,
            },
            fullscreenToggle: true,
            volumePanel: { inline: true },
            playbackRateMenuButton: true,
            pictureInPictureToggle: false,
          },
          playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
          castButton: false,
          textTrackSettings: true,
        },
        function onPlayerReady() {
          if (player !== null) {
            getTranscript(props.srt);
          }
        }
      )
    );

    Transcript(window, videojs);
  }, []);

  useEffect(() => {
    if (videoNode.current && player) {
      // alert(props.data.video);
      if (!player.paused()) {
        videoNode.current.pause();
      }
      player.removeRemoteTextTrack(textTrack);
      setTextTrack(null);
      player.src([
        {
          src: props.data.video,
          type: "application/x-mpegURL",
        },
      ]);
      videoNode.current.load();
      getTranscript(props.srt);
    }
  }, [props.data.video]);

  useEffect(() => {
    if (player !== null) {
      getTranscript(props.srt);

      window.addEventListener("resize", setTranscriptBtns());
    }
  }, [player]);

  const setTranscriptBtns = () => {
    const myButton = player.controlBar.addChild("button");
    myButton.addClass("transcript-btn");
    const myButtonDom = myButton.el();
    myButtonDom.innerHTML = `<span style="cursor: pointer; font-size: 14px">${t(`Transcript.string`)}</span>`;
    myButtonDom.style.display = window.innerWidth <= 720 ? "none" : "block";
    const myButton2 = player.controlBar.addChild("button");
    myButton2.addClass("transcript-btn");
    const myButtonDom2 = myButton2.el();
    myButtonDom2.innerHTML = `<span style="cursor: pointer; font-size: 14px; border-bottom: 1px solid white;">${t(`Transcript.string`)}</span>`;
    myButtonDom2.style.display = window.innerWidth <= 720 ? "none" : "none";

    myButtonDom.onclick = () => {
      setViewTranscript(true);
      myButtonDom.style.display = "none";
      myButtonDom2.style.display = "block";
    };
    myButtonDom2.onclick = () => {
      setViewTranscript(false);
      myButtonDom2.style.display = "none";
      myButtonDom.style.display = "block";
    };
  };

  const getTranscript = (url) =>
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(
        function (data) {
          const trackBlob = new Blob([srt2webvtt(data)], {
            type: "text/plain;charset=utf-8",
          });

          const captionOption = {
            default: true,
            kind: "captions",
            srclang: lang,
            label: `${lang == "en" ? "English" : "English"}`,
            src: URL.createObjectURL(trackBlob),
          };

          setTextTrack(player.addRemoteTextTrack(captionOption));

          const transcript = player.transcript({
            showTitle: false,
            showTrackSelector: false,
          });

          const node = ReactDOM.findDOMNode(transcriptArea.current);
          if (node.hasChildNodes()) {
            node.removeChild(node.firstChild);
          }

          node.appendChild(transcript.el());
        }.bind(player)
      );

  const srt2webvtt = (data) => {
    // remove dos newlines
    let srt = data.replace(/\r+/g, "");
    // trim white space start and end
    srt = srt.replace(/^\s+|\s+$/g, "");
    // get cues
    const cuelist = srt.split("\n\n");
    let result = "";
    if (cuelist.length > 0) {
      result += "WEBVTT\n\n";
      for (let i = 0; i < cuelist.length; i = i + 1) {
        result += convertSrtCue(cuelist[i]);
      }
    }
    return result;
  };

  const convertSrtCue = (caption) => {
    // remove all html tags for security reasons
    //srt = srt.replace(/<[a-zA-Z\/][^>]*>/g, '');
    let cue = "";
    const s = caption.split(/\n/);
    // concatenate muilt-line string separated in array into one
    while (s.length > 3) {
      for (let i = 3; i < s.length; i++) {
        s[2] += "\n" + s[i];
      }
      s.splice(3, s.length - 3);
    }
    let line = 0;
    // detect identifier
    if (!s[0].match(/\d+:\d+:\d+/) && s[1].match(/\d+:\d+:\d+/)) {
      cue += s[0].match(/\w+/) + "\n";
      line += 1;
    }
    // get time strings
    if (s[line].match(/\d+:\d+:\d+/)) {
      // convert time string
      const m = s[1].match(
        /(\d+):(\d+):(\d+)(?:,(\d+))?\s*--?>\s*(\d+):(\d+):(\d+)(?:,(\d+))?/
      );
      if (m) {
        cue +=
          m[1] +
          ":" +
          m[2] +
          ":" +
          m[3] +
          "." +
          m[4] +
          " --> " +
          m[5] +
          ":" +
          m[6] +
          ":" +
          m[7] +
          "." +
          m[8] +
          "\n";
        line += 1;
      } else {
        // Unrecognized timestring
        return "";
      }
    } else {
      // file format error or comment lines
      return "";
    }
    // get cue text
    if (s[line]) {
      cue += s[line] + "\n\n";
    }
    return cue;
  };

  return (
    <div className="basicVideo" id="basicVideo">
      <div
        className="heading"
        style={{ display: props.data.heading === "" ? "none" : null }}
      >
        {parse(t(`${props.data.heading}.string`))}
      </div>
      <div
        className="video-description"
        style={{ display: props.data.description === "" ? "none" : null }}
      >
        {t(`${props.data.description}.string`)}
      </div>
      <div className="video-container">
        <video
          ref={videoNode}
          className={`video-js custom-videojs-components vjs-big-play-centered vjs-fluid`}
          id="my-player"
          controls
          preload="true"
        >
          <track kind="captions" srcLang="en" label="English" default />
          <p className="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank">
              supports HTML5 video
            </a>
          </p>
        </video>
        <div
          className="custom-video-js-transcript"
          ref={transcriptArea}
          style={{ display: !viewTranscript ? "none" : null }}
        ></div>
      </div>
    </div>
  );
}
